import type { Role } from '@avisoma/shared';
import { useAuth } from '../hooks/useAuth';

export default function AuthGuard({
  children,
  role,
  roles,
  fallback,
}: {
  children: React.ReactNode;
  role?: Role;
  roles?: Role[];
  fallback?: React.ReactNode;
}) {
  const auth = useAuth();

  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  const normalizedRoles: Role[] = Array.isArray(roles) ? [...roles] : [];
  if (role) {
    normalizedRoles.push(role);
  }

  if (!auth.hasAccess(normalizedRoles)) {
    return fallback ?? <></>;
  }

  return <>{children}</>;
}
